import { combineReducers } from 'redux';
import themeReducer from './theme.reducer';
import authReducer from './auth.reducer';
import memoirReducer from './memoir.reducer';
import notificationReducer from './notification.reducer';
import userReducer from './user.reducer';
import feedbackReducer from './feedback.reducer';
import orderQrCodeReducer from './orderqrcode.reducer';
import futuremessageReducer from './futuremessage.reducer';
import searchReducer from './search.reducer';
import paymentReducer from './payment.reducer';
import collaborativeReducer from './collaborative.reducer';
import authUserReducer from './authUser.reducer';
import customersupportReducer from './cutomersupport.reducer';
import order_qr_cartReducer from './orderqrcart.reducer';
import bolgsReducer from './blogs.reducer';
import alertReducer from './alertReducers';
import { LOGOUT_SUCCESS } from '../actions/types';

const appReducer = combineReducers({
	auth: authReducer,
	authUser: authUserReducer,
	theme: themeReducer,
	memoir: memoirReducer,
	notification: notificationReducer,
	feedback: feedbackReducer,
	customerSupport: customersupportReducer,
	user: userReducer,
	search: searchReducer,
	collaborative: collaborativeReducer,
	payment: paymentReducer,
	orderQrCode: orderQrCodeReducer,
	orderQrCart: order_qr_cartReducer,
	future_message: futuremessageReducer,
	blogs: bolgsReducer,
	customAlert: alertReducer,
});
const rootReducer = (state, action) => {
	if (action.type === LOGOUT_SUCCESS) {
		return appReducer(undefined, action);
	}
	return appReducer(state, action);
};

export default rootReducer;
